export default __webpack_public_path__ + "static/media/20-100.6d10ec54.jpg";